// Claude: Admin Buyer FAQ page — manage buyer-facing FAQ entries 13-03-2026
import React from "react";
import KnowledgeBasePage from "./KnowledgeBasePage";

const BuyerFAQ = () => <KnowledgeBasePage type="buyer_faq" title="Buyer FAQ" />;

export default BuyerFAQ;
